import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './Page.css';
import './Kontakt.css';

const Kontakt = () => {
  const { t } = useTranslation();
  
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simulate form submission
    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitStatus('success');
      setFormData({ name: '', email: '', subject: '', message: '' });
    }, 2000);
  };

  const contactInfo = [
    {
      icon: '📧',
      title: 'Email',
      value: 'vivavoce.soprano@gmail.com',
      link: 'mailto:vivavoce.soprano@gmail.com'
    },
    {
      icon: '📍',
      title: 'Lokalizacja',
      value: 'Kraków, Stare miasto',
      link: '#'
    },
    {
      icon: '🎵',
      title: 'Facebook',
      value: '@jadwiga_kirschanek',
      link: 'https://facebook.com/jadwiga.kirschanek'
    }
  ];


  return (
    <div className="page">
      <div className="page-container">
        <div className="page-header">
          <h1>{t('contact.title')}</h1>
          <p className="page-subtitle">{t('contact.subtitle')}</p>
        </div>
        
        <div className="page-content">
          <div className="contact-grid">
            <div className="contact-info-section">
              <h2>{t('contact.contactInfo')}</h2>
              <div className="contact-cards">
                {contactInfo.map((info, index) => (
                  <a 
                    key={index} 
                    href={info.link}
                    className="contact-card"
                    target={info.link.startsWith('http') ? '_blank' : '_self'}
                    rel={info.link.startsWith('http') ? 'noopener noreferrer' : ''}
                  >
                    <div className="contact-icon">{info.icon}</div>
                    <div className="contact-details">
                      <h3>{info.title}</h3>
                      <p>{info.value}</p>
                    </div>
                  </a>
                ))}
              </div>

              <div className="teaching-info">
                <h3>{t('contact.teachingInfo')}</h3>
                <p>{t('contact.teachingDesc')}</p>
                <ul>
                  {t('contact.teachingDetails', { returnObjects: true }).map((detail, index) => (
                    <li key={index}>{detail}</li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="contact-form-section">
              <h2>{t('contact.sendMessage')}</h2>
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">{t('contact.name')} *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder={t('contact.namePlaceholder')}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">{t('contact.email')} *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder={t('contact.emailPlaceholder')}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="subject">{t('contact.subject')} *</label>
                  <select
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  >
                    <option value="">{t('contact.subjectPlaceholder')}</option>
                    <option value="nauczanie">{t('contact.subjectTeaching')}</option>
                    <option value="koncert">{t('contact.subjectConcert')}</option>
                    <option value="wspolpraca">{t('contact.subjectCollaboration')}</option>
                    <option value="inne">{t('contact.subjectOther')}</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="message">{t('contact.message')} *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="6"
                    placeholder={t('contact.messagePlaceholder')}
                  />
                </div>

                <button 
                  type="submit" 
                  className="submit-button"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? t('contact.sending') : t('contact.sendButton')}
                </button>

                {submitStatus === 'success' && (
                  <div className="success-message">
                    ✅ {t('contact.successMessage')}
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Kontakt;
